import { DataWizardColumnDataType } from '@grid-ui/common';

export const DATA_WIZARD_UPLOAD_ATTRIBUTE_TYPES_WHITELIST: DataWizardColumnDataType[] = [
  { type: 'string', label: 'Text' },
  { type: 'decimal', label: 'Number (decimal)' },
  { type: 'integer', label: 'Number (integer)' },
  { type: 'datetime', label: 'DateTime' },
];
